// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-size{display:block;max-width:100%;max-height:100%;width:auto;height:auto}.zoom .v-card,.zoom .v-card__text,.zoom.v-dialog{overflow:visible!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
